var map = {
	"./ic_aave_40.svg": 432,
	"./ic_anzor_40.svg": 433,
	"./ic_avax_40.svg": 434,
	"./ic_btc_40.svg": 435,
	"./ic_dai_40.svg": 436,
	"./ic_equity_40.svg": 437,
	"./ic_eth_40.svg": 268,
	"./ic_frax_40.svg": 438,
	"./ic_ftm_40.svg": 439,
	"./ic_glp_40.svg": 440,
	"./ic_gmx_40.svg": 441,
	"./ic_link_40.svg": 442,
	"./ic_matic_40.svg": 443,
	"./ic_mim_40.svg": 444,
	"./ic_mvlp_40.svg": 445,
	"./ic_mvx_40.svg": 446,
	"./ic_uni_40.svg": 447,
	"./ic_usdc.e_40.svg": 448,
	"./ic_usdc_40.svg": 449,
	"./ic_usdt_40.svg": 450,
	"./ic_wavax_40.svg": 451,
	"./ic_weth_40.svg": 452,
	"./ic_wftm_40.svg": 453,
	"./ic_wmatic_40.svg": 454
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 230;